import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Hero interaction tracking (fire-and-forget)
export const trackHeroEvent = async (item, type) => {
  try {
    await axios.post(`${API}/hero/event`, { item, type });
  } catch (error) {
    // silent - analytics must never block UX
  }
};

// Settings API
export const getSettings = async () => {
  try {
    const response = await axios.get(`${API}/settings`);
    return response.data;
  } catch (error) {
    console.error('Error fetching settings:', error);
    throw error;
  }
};

export const updateSettings = async (settingsData) => {
  try {
    const response = await axios.put(`${API}/settings`, settingsData);
    return response.data;
  } catch (error) {
    console.error('Error updating settings:', error);
    throw error;
  }
};

// Gallery API
export const getGalleryImages = async (category = null) => {
  try {
    const url = category ? `${API}/gallery?category=${category}` : `${API}/gallery`;
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching gallery images:', error);
    throw error;
  }
};

export const createGalleryImage = async (imageData) => {
  try {
    const response = await axios.post(`${API}/gallery`, imageData);
    return response.data;
  } catch (error) {
    console.error('Error creating gallery image:', error);
    throw error;
  }
};

export const updateGalleryImage = async (imageId, imageData) => {
  try {
    const response = await axios.put(`${API}/gallery/${imageId}`, imageData);
    return response.data;
  } catch (error) {
    console.error('Error updating gallery image:', error);
    throw error;
  }
};

export const deleteGalleryImage = async (imageId) => {
  try {
    const response = await axios.delete(`${API}/gallery/${imageId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting gallery image:', error);
    throw error;
  }
};

// Categories API
export const getCategories = async () => {
  try {
    const response = await axios.get(`${API}/categories`);
    return response.data;
  } catch (error) {
    console.error('Error fetching categories:', error);
    throw error;
  }
};

// Track gallery image view (public)
export const trackImageView = async (imageId) => {
  try {
    await axios.post(`${API}/gallery/${imageId}/view`);
  } catch (error) {
    // Non-critical: silently ignore so UX isn't impacted
    console.debug('View tracking failed:', error?.message);
  }
};

// Contact API
export const submitContactForm = async (contactData) => {
  try {
    const response = await axios.post(`${API}/contact`, contactData);
    return response.data;
  } catch (error) {
    console.error('Error submitting contact form:', error);
    throw error;
  }
};

export const getContactMessages = async (status = null) => {
  try {
    const url = status ? `${API}/contact?status=${status}` : `${API}/contact`;
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching contact messages:', error);
    throw error;
  }
};
